var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRemoveSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icRemoveSearch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---search--start",
    transform: "translate(-276.000000, -184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icRemoveSearch",
    transform: "translate(276.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5001777,15 C11.6311928,15 15,11.6311928 15,7.5001777 C15,3.36916261 11.6311928,0 7.5001777,0 C3.36916261,0 0,3.36916261 0,7.5001777 C0,11.6311928 3.36916261,15 7.5001777,15 Z",
    id: "Stroke-1",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#BBBBBB",
    points: "10.5 4.84776 10.1522086 4.5 7.50005988 7.15236 4.84791114 4.5 4.5 4.84776 7.15214875 7.50012 4.5 10.15224 4.84791114 10.5 7.50005988 7.84788 10.1522086 10.5 10.5 10.15224 7.84761173 7.50012"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    points: "10.5 4.84776 10.1522086 4.5 7.50005988 7.15236 4.84791114 4.5 4.5 4.84776 7.15214875 7.50012 4.5 10.15224 4.84791114 10.5 7.50005988 7.84788 10.1522086 10.5 10.5 10.15224 7.84761173 7.50012"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemoveSearch);
export default __webpack_public_path__ + "static/media/icRemoveSearch.d5d2b297c2e45acb2054570f40843d2e.svg";
export { ForwardRef as ReactComponent };